import { formatDistanceToNow, parseISO } from 'date-fns';

export const formatToastRelativeTimestamp = (timestamp: string): string =>
  formatDistanceToNow(parseISO(timestamp), {
    addSuffix: true,
  });
